import { ArrowIcon, Card, DocumentIcon } from '@autoplan/web-ui'
import { useNavigate } from 'react-router-dom'

type MyTaskCardProps = {
  label: string
  subLabel: string
  taskCount?: number
  href: string
}

export const MyTaskCard = ({ label, subLabel, taskCount, href }: MyTaskCardProps) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(href)
  }

  return (
    <Card className="ap:px-2xl ap:py-xl " onClick={handleClick}>
      <div className="ap:flex ap:items-center ap:justify-between ap:gap-xl">
        <div className="ap:flex ap:min-w-0 ap:items-center ap:gap-lg">
          <span className="ap:flex ap:size-3xl ap:shrink-0 ap:items-center ap:justify-center ap:rounded-full ap:bg-surface-primary-hover ap:text-content-secondary">
            <DocumentIcon />
          </span>
          <div className="ap:min-w-0">
            <h2 className="ap:truncate ap:text-[16px] ap:font-semibold ap:leading-tight ap:text-content-primary">
              {label}
            </h2>
            <p className="ap:truncate ap:pt-2xs ap:text-sm ap:text-content-secondary">{subLabel}</p>
          </div>
        </div>
        <div className="ap:flex ap:shrink-0 ap:items-center ap:gap-lg ap:text-content-secondary">
          {typeof taskCount === 'number' && (
            <span className="ap:flex ap:size-2xl ap:items-center ap:justify-center ap:rounded-full ap:bg-primary ap:text-xs ap:font-semibold ap:text-[#FFFFFF]">
              {taskCount}
            </span>
          )}
          <ArrowIcon />
        </div>
      </div>
    </Card>
  )
}
